import { Module } from "vuex";
import { IFinancialProfileState } from "@/core/interfaces/financialProfileState.interface";
import { StoreState } from "@/store/type";

import mutations from "./mutations";
import actions from "./actions";
import state from "./state";
import getters from "./getters";

const financialProfileModule: Module<IFinancialProfileState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default financialProfileModule;
